import {$, Backbone} from 'backboneAdapter';
import Handlebars from 'handlebars';
import PaginatedView from 'js/views/pagination.view';
import DetailedRedemptionsTemplate from 'js/templates/detailed.redemptions.hbs';
import VoucherRedemptionCollection from "../models/voucher.redemption.paginated.collection";
import {RedemptionsChartView} from "./redemptions.chart.simpleview";
import EmailApiKeyTemplate from 'js/templates/partials/redeemer-email-apiKey.partial.hbs';
import i18n from "l10n";
import dhtmlx from "dhtmlxAdapter";
import {className, debounce, el, on, tagName} from "../adapters/backbone-decorators";
import QRCode from "qrcode";

@el("#redemptionDetails")
@tagName('div')
@className('')
class RedemptionsView extends Backbone.View {
    detailedRedemptionsTemplate = Handlebars.compile(DetailedRedemptionsTemplate);
    emailApiKeyTemplate = Handlebars.compile(EmailApiKeyTemplate);

    constructor(options) {
        super(options);
        const {redeemer} = options;
        this.redeemer = redeemer;
        // this.superInitialize();
        this.redemptionsChartView = new RedemptionsChartView("#redeemersHistoryContainer", this.redeemer.id);
        this.collection = new (VoucherRedemptionCollection.extend({userId: redeemer.id}));
        this.collection.on('sync', () => {
            this.render();
        }, this);

        this.collection.getFirstPage();
    }

    render() {
        this.$el.html(this.detailedRedemptionsTemplate({
            redeemer: this.redeemer,
            search: this.collection.filters,
            redemptions: this.collection.data,
            count: this.collection.length,
            totalRedemptions: this.collection.extras.totalRedemptions
        }));
        this.redemptionsChartView.render();
        const hasRedemptions = this.collection.extras.totalRedemptions > 0;
        $("#voucherssearchbox").toggle(hasRedemptions);
        this.renderPagination();
    }

    renderPagination() {
        if (this.pagination) {
            this.pagination.remove();
        }
        this.pagination = new PaginatedView({collection: this.collection});
        this.pagination.render();
        // Replace view's pagination
        this.$('#detailed-report-pagination').html(this.pagination.$el);
    }

    @on('click #redeemersHistoryContainer .timegranule-buttons > button')
    granuleHandler(evt) {
        const btn = $(evt.currentTarget);
        const tg = btn.attr("data-timegranule");

//set the clicked button to active
        btn.parent().find(".active").removeClass("active");
        btn.addClass("active");

        this.redemptionsChartView.setWindow(tg);
        this.redemptionsChartView.refresh();
    }

    @on('click #redeemersHistoryContainer .zoom-buttons .minus', -1)
    @on('click #redeemersHistoryContainer .zoom-buttons .plus', 1)
    zoomHandler(inc, ev) {
        if (!$(ev.currentTarget).hasClass('disabled')) {
            this.redemptionsChartView.moreLessDetails(inc);
        }

    }

    @on('click #redeemersHistoryContainer .pagination .prev', 'subtract')
    @on('click #redeemersHistoryContainer .pagination .next', 'add')
    historyPagination(method, ev) {
        if (!$(ev.currentTarget).hasClass('disabled')) {
            this.redemptionsChartView.options.from[method](1, `${this.redemptionsChartView.options.window}s`);
            this.redemptionsChartView.setWindow(this.redemptionsChartView.options.window);
            this.redemptionsChartView.refresh();
        }
    }

    @on('click #refreshDetailedReportKey')
    async refreshDetailedReportKey() {
        //refresh ApiKey and Description

        const result = await dhtmlx.modalbox({
            title: i18n.t("voucher.refreshUserKey"),
            text: i18n.t("voucher.areYouSureChangeKey"),
            buttons: [i18n.t("message.yes"), i18n.t("message.no")]
        });
        if (result === "0") this.trigger('change:apiKey', this.redeemer);

    }

    @on('click #qrCodeApiKey')
    async qrCodeApiKey(evt) {
        const $redeemerApiKeyQRCode = $("#redeemerApiKeyQRCode");
        if ($redeemerApiKeyQRCode.attr("src") !== "") {
            $redeemerApiKeyQRCode.parent().toggle();
            return;
        }

        const link = $(evt.currentTarget).data("link");
        const url = await QRCode.toDataURL(link, {scale: 7});
        $('#qrcode').attr("src", url);
        $redeemerApiKeyQRCode.attr("src", url);
        $redeemerApiKeyQRCode.parent().show();

    }

    @on('click #currentRedeemerDescription')
    editDescription() {
        var $currentRedeemerDescription = $("#currentRedeemerDescription");
        var currentDescription = $currentRedeemerDescription.text();
        var $currentRedeemerDescriptionInput = $("#currentRedeemerDescriptionInput");
        $currentRedeemerDescriptionInput.val(currentDescription);
        $("#editDescription").show();
        $currentRedeemerDescription.hide();
        $currentRedeemerDescriptionInput.focus();
    }

    @on('click #currentRedeemerEmail')
    editEmail() {
        var $currentRedeemerEmail = $("#currentRedeemerEmail");
        var currentEmail = $currentRedeemerEmail.text();
        var $currentRedeemerEmailInput = $("#currentRedeemerEmailInput");
        $currentRedeemerEmailInput.val(currentEmail);
        $("#editEmail").show();
        $currentRedeemerEmail.parent().hide();
        $currentRedeemerEmailInput.focus();
    }

    @on('keyup #currentRedeemerDescriptionInput')
    saveNewDescriptionOnEnterPress(evt) {
        var keyCode = evt.which;
        if (keyCode === 13)
            $("#submitNewDescription").trigger("click");
    }

    @on('keyup #currentRedeemerEmailInput')
    saveNewEmailOnEnterPress(evt) {
        var keyCode = evt.which;
        if (keyCode === 13)
            $("#submitNewEmail").trigger("click");
    }

    @on('click #mailRedeemerUrl')
    async mailRedeemerUrl(e) {
        e.preventDefault();
        var apiKey = $("#currentRedeemerKey").text();
        var link = $("#currentRedeemerUrl").text();
        var email = $("#currentRedeemerEmail").text();

        var subject = i18n.t("voucher.redeemerUrlEmailSubject");
        const url = await QRCode.toDataURL(apiKey, {scale: 7});
        var emailBody = encodeURIComponent(this.emailApiKeyTemplate({
            apiKey,
            url,
            link,
            isPostpaid: this.isPostpaid
        }));
        window.location = `mailto:${email}?subject=${subject}&body=${emailBody}`;
    }

    @on('click #submitNewDescription')
    async submitRedeemerDescription() {
        try {
            var newDescription = $("#currentRedeemerDescriptionInput").val();
            if (!newDescription) return;
            const response = await $.ajaxDefaultQ({
                url: `/CampaignCloud/ApiUser/${this.redeemer.id}/updateDescription`,
                type: 'PUT',
                data: newDescription,
                traditional: true,
                contentType: 'application/json'
            });
            var $currentRedeemerDescription = $("#currentRedeemerDescription");
            if (response.outcome !== "OK") {
                $.Notify.error(i18n.t("generic.attributechanged", {outcome: response.data}));
            } else {
                $currentRedeemerDescription.text(newDescription);
                this.redeemer.description = newDescription;
                this.trigger("change:user", {user: this.redeemer});
                $.Notify.show(i18n.t("generic.attributechanged", {outcome: response.outcome}));
            }
            $("#editDescription").hide();
            $currentRedeemerDescription.show();
        } catch (e) {
            console.error(e);
            $.Notify.error(`Error: ${e}`);
        }
    }

    @on('click #submitNewEmail')
    async submitRedeemerEmail() {
        try {
            var newEmail = $("#currentRedeemerEmailInput").val();
            if (!newEmail)
                return;
            const response = await $.ajaxDefaultQ({
                url: `/CampaignCloud/ApiUser/${this.redeemer.id}/updateEmail`,
                type: 'PUT',
                data: newEmail,
                traditional: true,
                contentType: 'application/json'
            });
            var $currentRedeemerEmail = $("#currentRedeemerEmail");
            if (response.outcome !== "OK") {
                $.Notify.error(i18n.t("generic.attributechanged", {outcome: response.data}));
            } else {
                $currentRedeemerEmail.text(newEmail);
                this.redeemer.email = newEmail;
                this.trigger("change:user", {user: this.redeemer});
                $.Notify.show(i18n.t("generic.attributechanged", {outcome: response.outcome}));
            }
            $("#editEmail").hide();
            $currentRedeemerEmail.parent().show();
        } catch (e) {
            console.error(e);
            $.Notify.error(`Error: ${e}`);
        }

    }

    @on('click #cancelNewDescription')
    cancelNewDescription() {
        $("#editDescription").hide();
        $("#currentRedeemerDescription").show();
    }

    @on('click #cancelNewEmail')
    cancelNewEmail() {
        $("#editEmail").hide();
        $("#currentRedeemerEmail").parent().show();
    }

    @on('keyup .voucherssearchbox')
    @debounce(800)
    searchRedemptionsByFilter() {
        this.$('.voucherssearchbox').each((index, elem) => {
            var val = $(elem).val() ? $(elem).val() : null;

            if (val) {
                var text = val.toLowerCase();
                text = text.replace(/^.*-/, "");
                this.collection.userId = this.redeemer.id;
                this.collection.filters = text;
            } else {
                this.collection.userId = this.redeemer.id;
                this.collection.filters = null;
            }

            this.collection.getFirstPage();
        });
    }
}

export default RedemptionsView;

